import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconParagraph: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"paragraph"} maskId="square-filled-radius-0-stroke-1-IconParagraph"><path fillRule="evenodd" clipRule="evenodd" d="M7.75 4C5.54086 4 3.75 5.79086 3.75 8C3.75 10.2091 5.54086 12 7.75 12H9V4H7.75ZM10 4V21H9V13H7.75C4.98858 13 2.75 10.7614 2.75 8C2.75 5.23858 4.98858 3 7.75 3H21V4H16V21.0775H15V4H10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconParagraph;
